export const environment = {
  production: true,
  url_admission_api: 'https://admin.people.test.private.unico.run/svc2',
  url_admission_form_api: 'https://form.people.test.private.unico.run/svc2',
  url_ongoing_api: 'https://api.collaborators.people.test.private.unico.run/api/v1',
  url_benefits_api: 'https://admin.people.test.private.unico.run/api/benefits/v1',
  url_routing_api: 'https://admin.people.test.private.unico.run/api/routing/v1',
  cdn_url: 'https://admin.people.test.private.unico.run/cdn2',
  svc1_url: 'https://test-form.acessorh.com.br/svc2',
  identity_url: 'https://identityqa.acesso.io',
  sign_url: 'https://sign-core-test.acesso.io',
  sign_id: 'DB8EF2DD966F2CE9F3237F1A1746143B346393D373C7268FFC32759DE06597EA',
  segment_key: 'aJSx6ITwDTBcFEq6je022Y0UrC52Khm1',
  admission_url: 'https://admin.people.test.private.unico.run',
  ongoing_url: 'https://collaborators.people.test.private.unico.run',
  benefits_url: 'https://benefits.people.test.private.unico.run',
  redirect_uri_admission: 'https://admin.people.test.private.unico.run/preauthorize',
  redirect_uri_ongoing: 'https://collaborators.people.test.private.unico.run/preauthorize',
  redirect_uri_benefits: 'https://benefits.people.test.private.unico.run/preauthorize',
  redirect_uri: 'https://test-web-form.acessorh.com.br/callback',
  base_sign_url: 'https://sign-test.acesso.io/bff/v1',
  productId: "99c3dfc5-7518-4d7c-9e75-e54d920721fd",
  launchDarklyClientId: '63b870113b5a4212abb0f0fa',
  url_benefits: 'https://benefits.people.test.private.unico.run/',
  mixpanel_token: 'f4069d9b550ea08e34089810c2abd5be',
};
